import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * Keeps the transcript pinned to the bottom while new tokens stream in, but
 * stops fighting the user the moment they scroll up to read history.
 */
export function useAutoScroll(deps) {
    const ref = useRef(null);
    const pinnedRef = useRef(true);
    const [showJumpButton, setShowJumpButton] = useState(false);
    const scrollToBottom = useCallback((behavior = 'smooth') => {
        const node = ref.current;
        if (!node)
            return;
        node.scrollTo({ top: node.scrollHeight, behavior });
        pinnedRef.current = true;
        setShowJumpButton(false);
    }, []);
    const onScroll = useCallback(() => {
        const node = ref.current;
        if (!node)
            return;
        const distance = node.scrollHeight - node.scrollTop - node.clientHeight;
        pinnedRef.current = distance < 64;
        setShowJumpButton(!pinnedRef.current);
    }, []);
    useEffect(() => {
        if (pinnedRef.current)
            scrollToBottom('auto');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return { ref, onScroll, scrollToBottom, showJumpButton };
}
